import React, { Component } from 'react';
import { connect } from 'react-redux';
import { REDUCER_NAME } from './reducer';
import Doughnut from './../../common/donut-chart/Doughnut';
import { I18n } from 'react-redux-i18n';

class ChartOwnerShip extends Component {
  render() {
    //dougnut chart overview
    const { overViewChartData } = this.props;
    const colorsOverview = ['#45b29d', '#facc5c', '#df5a49'];
    const title = I18n.t(`ownerShip.titleChart.overview`);

    //dougnut chart major ownerships
    const { majorOwnerShipChartData } = this.props;
    const colorsMajorOwnership = [
      '#f46139',
      '#feff9d',
      '#beeb9f',
      '#79bd8f',
      '#45b29d',
    ];
    const titleMajor = I18n.t(`ownerShip.titleChart.marjorOwnership`);

    return (
      <div>
        <Doughnut
          listData={overViewChartData}
          colors={colorsOverview}
          title={title}
          tooltipPaddingX={50}
          tooltipPaddingY={150}
        />
        <div className="mt-10 mb-10" />
        <Doughnut
          listData={majorOwnerShipChartData}
          colors={colorsMajorOwnership}
          title={titleMajor}
          tooltipPaddingX={50}
          tooltipPaddingY={195}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, { id }) => {
  return {
    i18n: state.i18n,
    overViewChartData:
      state[REDUCER_NAME].listMultiComponent[id].overViewChartData,
    majorOwnerShipChartData:
      state[REDUCER_NAME].listMultiComponent[id].majorOwnerShipChartData,
  };
};

export default connect(mapStateToProps)(ChartOwnerShip);
